if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.target = document.querySelector(this.dataset.target);
        this.button = this.querySelector('.sticky-atc__button');
        if (!this.target || !this.button) return;

        this.button.addEventListener('click', () => {
          if (this.target.disabled) return;
          this.target.click();
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            const visible = entries[0].isIntersecting;
            const below = entries[0].boundingClientRect.top < 0;
            const show = !visible && below;
            this.classList.toggle('is-visible', show);
            this.inert = !show;
            document.body.classList.toggle('sticky-atc-visible', show);
          },
          { threshold: 0 }
        );
        this.observer.observe(this.target);

        // Keep label and state in sync with the main button (variant changes).
        this.sync = new MutationObserver(() => {
          this.button.disabled = this.target.disabled;
          const span = this.target.querySelector('span');
          if (span) this.button.textContent = span.textContent.trim();
        });
        this.sync.observe(this.target, { attributes: true, childList: true, subtree: true });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.sync) this.sync.disconnect();
      }
    }
  );
}
